import { TOGGLE_DEGREE_FILTER_MENU } from './constants';

export function toggleDegreeFilterMenu(value) {
  return {
    type: TOGGLE_DEGREE_FILTER_MENU,
    value,
  };
}
